/* src/app/system-utils/message-dialog/message-dialog.component.scss */
.app-dialog {
  padding: 20px;
}
.app-dialog__header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}
.app-dialog__chip {
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}
.app-dialog__title {
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--tem-ink);
  margin: 0;
  line-height: 1.3;
}
.app-dialog--error .app-dialog__chip {
  color: var(--tem-danger);
  border-color: var(--tem-danger);
  background: color-mix(in srgb, var(--tem-danger) 10%, transparent);
  animation: chip-pulse 2.4s ease-in-out infinite;
}
.app-dialog--info .app-dialog__chip {
  color: var(--tem-warn);
  border-color: var(--tem-warn);
  background: color-mix(in srgb, var(--tem-warn) 10%, transparent);
  animation: chip-pulse 2.4s ease-in-out infinite;
}
.app-dialog--quiz .app-dialog__chip {
  color: var(--tem-deep);
  border-color: var(--tem-deep);
  background: var(--tem-accent-soft);
}
@keyframes chip-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
  50% {
    box-shadow: 0 0 0 6px color-mix(in srgb, var(--tem-ink) 6%, transparent);
  }
}
@media (prefers-reduced-motion: reduce) {
  .app-dialog__chip {
    animation: none;
  }
}
.app-dialog__body {
  margin-bottom: 22px;
}
.app-dialog__status {
  font-size: 0.85rem;
  color: var(--tem-muted);
  margin: 0 0 6px;
}
.app-dialog__status strong {
  color: var(--tem-ink);
}
.app-dialog__lead {
  font-size: 0.92rem;
  color: var(--tem-muted);
  margin: 0 0 12px;
}
.app-dialog__message {
  background: var(--tem-surface-2);
  border-radius: 10px;
  border-left: 3px solid var(--tem-deep);
  padding: 14px 16px;
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
  font-size: 0.85rem;
  line-height: 1.55;
  color: var(--tem-ink);
  word-break: break-word;
  max-height: 260px;
  overflow-y: auto;
}
.app-dialog--error .app-dialog__message {
  border-left-color: var(--tem-danger);
}
.app-dialog--info .app-dialog__message {
  border-left-color: var(--tem-warn);
}
.app-dialog--quiz .app-dialog__message {
  border-left-color: var(--tem-deep);
}
.app-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
/*# sourceMappingURL=message-dialog.component.css.map */
